import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class DataService {

  constructor() { }
  shareDataSubject = new Subject<any>(); //Decalring new RxJs Subject
  vehicleIdSubject = new Subject<any>(); //Decalring new RxJs Subject

  sendDataToOtherComponent(somedata) {
    this.shareDataSubject.next(somedata);
  }

  saveVehicleInfo(vehicleInfo) {
    this.vehicleIdSubject.next(vehicleInfo);
  }
}
